// extracted by mini-css-extract-plugin
export var header = "style-module--header--TW5Wp";
export var logo = "style-module--logo--iz8pw";
export var logowrap = "style-module--logowrap--NYTJQ";
export var simpleHeaderBtn = "style-module--simpleHeaderBtn--LG7vq";
export var thanksheader = "style-module--thanksheader--d8T9p";
export var thankslogowrap = "style-module--thankslogowrap--aiTi3";
export var thankswrapper = "style-module--thankswrapper--fqkCd";
export var wrapper = "style-module--wrapper--2uKkP";